import { useState, useEffect } from 'react';
import {
  Container,
  Table,
  Button,
  Form,
  Modal,
  Alert,
  Tabs,
  Tab,
  Row,
  Col
} from 'react-bootstrap';
import { db, auth } from '../firebase';
import {
  collection,
  doc,
  getDoc,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  onSnapshot,
  where,
  Timestamp
} from 'firebase/firestore';
 import {
     signInWithEmailAndPassword,
     signOut,
     setPersistence,
     browserLocalPersistence,onAuthStateChanged
   } from 'firebase/auth';
   

const InventoryLogin = ({ setUser }) => {
  const [error, setError] = useState('');
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = e.target.elements;
    try {
      await setPersistence(auth, browserLocalPersistence);

      const userCred = await signInWithEmailAndPassword(auth, email.value, password.value);
      const userDoc = await getDoc(doc(db, 'users', userCred.user.uid));
      if (!userDoc.exists()) throw new Error('Usuario no registrado');
      const userData = userDoc.data();
      if (userData.password !== password.value) throw new Error('Credenciales inválidas');
      setUser({ ...userCred.user, storeId: userData.storeId });
    } catch (err) {
      setError(err.message);
      console.error('Error de autenticación:', err);
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <div className="auth-box p-5 rounded-3 shadow" style={{ maxWidth: '400px', width: '100%' }}>
        <h2 className="text-center mb-4">Acceso Inventario</h2>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Usuario</Form.Label>
            <Form.Control name="email" type="email" placeholder="ej: ArzuAlajuela" required />
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Label>Contraseña</Form.Label>
            <Form.Control name="password" type="password" required />
          </Form.Group>
          {error && <Alert variant="danger">{error}</Alert>}
          <Button variant="primary" type="submit" className="w-100">
            Ingresar
          </Button>
        </Form>
      </div>
    </Container>
  );
};

const STORES = ['ArzúBC', 'ArzúSF', 'ArzúHeredia', 'ArzúAlajuela'];
const CATEGORIAS_INICIALES = [
  'Pokémon',
  'OnePiece',
  'Shadowverse Evolve',
  'Digimon',
  'Grand archive',
  'Weisschwarz',
  'vanguard',
  'Otros',
  'Accesorios'
];
const GAME_CATEGORIES_INICIALES = {
  "Pokémon": ["Tin", "Collections", "ETB", "Bundle", "Booster Box", "Starter decks", "Accesorios", "Blister", "Booster", "Producto Premiun", "Double Pack", "mini tin"],
  "OnePiece": ["Starter Deck", "Booster Box", "Double packs", "Accesorios", "Tin", "collection", "productos premiun"],
  "Shadowverse Evolve": ["Starter Deck", "Booster Box", "Producto premiun"],
  "Digimon": ["Starter Deck", "Booster Box", "Double packs", "Accesorios", "collection", "productos premiun"],
  "Grand archive": ["Starter Deck", "Booster Box", "Producto premiun", "Accesorios"],
  "Weisschwarz": ["Starters deck", "booster box", "special boosters", "Accesorios"],
  "vanguard": ["Starters", "booster box", "Producto premiun", "Accesorios"],
  "Otros": [],
  "Accesorios": ["Matpods", "Playmats", "Binder", "Deck Box", "Accesorios Premiun"]
};
const TIPOS = ['Accesorios', 'ETB', 'Booster Box', 'Bundle', 'Starterdeck', 'Playmarth'];



const InventoryPanel = ({ user, handleLogout }) => {
  
  const [categorias, setCategorias] = useState(CATEGORIAS_INICIALES);
const [gameCategoriesState, setGameCategoriesState] = useState(GAME_CATEGORIES_INICIALES);
  const isMaster = user.email === "master@arzu.com";
  const [allInventory, setAllInventory] = useState({});
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [activeTab, setActiveTab] = useState(user.storeId);
  const [showCreateProductModal, setShowCreateProductModal] = useState(false);
  const [createProductData, setCreateProductData] = useState({});
  const [showAddInventoryModal, setShowAddInventoryModal] = useState(false);
  const [addInventoryData, setAddInventoryData] = useState({ productId: '', cantidad: '', catalog: true });
  const [showEditProductModal, setShowEditProductModal] = useState(false);
  const [selectedEditProductId, setSelectedEditProductId] = useState('');
  const [editProductData, setEditProductData] = useState({});
  const [searchText, setSearchText] = useState('');
  const [filterCategory, setFilterCategory] = useState('');
  const [productCatalog, setProductCatalog] = useState([]);
  const [showSaleModal, setShowSaleModal] = useState(false);
  const [saleProduct, setSaleProduct] = useState(null);
  const [saleUnits, setSaleUnits] = useState("");
  const [showRemoveQuantityModal, setShowRemoveQuantityModal] = useState(false);
  const [removeProduct, setRemoveProduct] = useState(null);
  const [removeUnits, setRemoveUnits] = useState("");
  

  useEffect(() => {
    const unsubscribers = [];
    STORES.forEach((storeId) => {
      const q = query(collection(db, 'stores', storeId, 'inventario'));
      const unsubscribe = onSnapshot(q, (snapshot) => {
        const data = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id, storeId }));
        setAllInventory((prev) => ({ ...prev, [storeId]: data }));
      });
      unsubscribers.push(unsubscribe);
    });
    return () => unsubscribers.forEach((unsub) => unsub());
  }, []);

  useEffect(() => {
    const q = collection(db, 'inventoryProducts');
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
      setProductCatalog(data);
    });
    return () => unsubscribe();
  }, []);

  const calculateTotalInventory = () => {
    const inventoryMap = {};
    Object.values(allInventory).flat().forEach((item) => {
      if (!inventoryMap[item.nombre]) {
        inventoryMap[item.nombre] = { tiendas: {}, total: 0, valor: 0 };
      }
      inventoryMap[item.nombre].tiendas[item.storeId] = item.cantidad;
      inventoryMap[item.nombre].total += item.cantidad;
      inventoryMap[item.nombre].valor += item.cantidad * item.precioPublico;
    });
    return inventoryMap;
  };

    // *** FUNCIÓN PARA GUARDAR CAMBIOS DE EDICIÓN ***
    const handleEditProductSubmit = async (e) => {
      e.preventDefault();
      if (!selectedEditProductId) {
        setError("Seleccione un producto para editar");
        return;
      }
      try {
        const required = ['nombre', 'imageURL', 'categoria', 'tipo', 'precioDistribuidor', 'precioPublico'];
        const missing = required.filter(f => !editProductData[f]);
        if (missing.length) throw new Error(`Faltan: ${missing.join(', ')}`);
        const ref = doc(db, 'inventoryProducts', selectedEditProductId);
        await updateDoc(ref, {
          nombre: editProductData.nombre,
          imageURL: editProductData.imageURL,
          descripcion: editProductData.descripcion || '',
          categoria: editProductData.categoria,
          tipo: editProductData.tipo,
          precioDistribuidor: Number(editProductData.precioDistribuidor),
          precioPublico: Number(editProductData.precioPublico)
        });
        setSuccess('Producto actualizado');
        setShowEditProductModal(false);
        setSelectedEditProductId('');
        setEditProductData({});
      } catch (err) {
        setError(err.message);
      }
      setTimeout(() => { setError(''); setSuccess(''); }, 3000);
    };
  

  const handleCreateProductSubmit = async (e) => {
    e.preventDefault();
    try {
      const required = ['nombre', 'imageURL', 'categoria', 'tipo', 'precioDistribuidor', 'precioPublico'];
      const missing = required.filter((field) => !createProductData[field]);
      if (missing.length > 0) throw new Error(`Campos requeridos: ${missing.join(', ')}`);
      const productData = {
        nombre: createProductData.nombre,
        imageURL: createProductData.imageURL,
        descripcion: createProductData.descripcion || '',
        categoria: createProductData.categoria,
        tipo: createProductData.tipo,
        precioDistribuidor: Number(createProductData.precioDistribuidor),
        precioPublico: Number(createProductData.precioPublico),
        activo: false,
        createdAt: Timestamp.fromDate(new Date())
      };
      await addDoc(collection(db, 'inventoryProducts'), productData);
      setSuccess('Producto creado en catálogo de inventario');
      setShowCreateProductModal(false);
      setCreateProductData({});
    } catch (err) {
      setError(err.message);
    }
    setTimeout(() => { setError(''); setSuccess(''); }, 3000);
  };

  const handleDeleteProduct = async (productId, storeId) => {
    if (!window.confirm('¿Eliminar este producto del inventario?')) return;
    try {
      await deleteDoc(doc(db, 'stores', storeId, 'inventario', productId));
      setSuccess('Producto eliminado del inventario');
    } catch (err) {
      setError('Error al eliminar el producto: ' + err.message);
    }
    setTimeout(() => { setError(''); setSuccess(''); }, 3000);
  };

  const handleAddInventorySubmit = async (e) => {
    e.preventDefault();
    try {
      if (!addInventoryData.productId || !addInventoryData.cantidad)
        throw new Error('Seleccione un producto y especifique la cantidad');
      const cantidadToAdd = Number(addInventoryData.cantidad);
      if (cantidadToAdd <= 0) throw new Error('La cantidad debe ser mayor a 0');
      const product = productCatalog.find((p) => p.id === addInventoryData.productId);
      if (!product) throw new Error('Producto no encontrado en el catálogo de inventario');
      const storeRef = collection(db, 'stores', user.storeId, 'inventario');
      const existing = allInventory[user.storeId]?.find((item) => item.productId === product.id);
      if (existing) {
        await updateDoc(doc(storeRef, existing.id), {
          cantidad: existing.cantidad + cantidadToAdd,
          lastUpdated: Timestamp.fromDate(new Date())
        });
      } else {
        await addDoc(storeRef, {
          productId: product.id,
          nombre: product.nombre,
          imageURL: product.imageURL,
          categoria: product.categoria,
          tipo: product.tipo,
          precioDistribuidor: product.precioDistribuidor,
          precioPublico: product.precioPublico,
          cantidad: cantidadToAdd,
          ventas: 0,
          createdAt: Timestamp.fromDate(new Date()),
          lastUpdated: Timestamp.fromDate(new Date())
        });
      }
      await updateDoc(doc(db, 'inventoryProducts', product.id), { [`activo.${user.storeId}`]: addInventoryData.catalog });
      setSuccess('Producto añadido al inventario');
      setShowAddInventoryModal(false);
      setAddInventoryData({ productId: '', cantidad: '', catalog: true });
    } catch (err) {
      setError(err.message);
    }
    setTimeout(() => { setError(''); setSuccess(''); }, 3000);
  };

  const handleSaleSubmit = async (e) => {
    e.preventDefault();
    if (!saleProduct) return;
    const unitsToSell = Number(saleUnits);
    if (unitsToSell <= 0) {
      setError("La cantidad a vender debe ser mayor a 0");
      return;
    }
    if (unitsToSell > saleProduct.cantidad) {
      setError("No hay suficientes unidades en inventario");
      return;
    }
    try {
      const newCantidad = saleProduct.cantidad - unitsToSell;
      const newVentas = (saleProduct.ventas || 0) + (unitsToSell * saleProduct.precioPublico);
      await updateDoc(doc(db, 'stores', user.storeId, 'inventario', saleProduct.id), {
        cantidad: newCantidad,
        ventas: newVentas,
        lastUpdated: Timestamp.fromDate(new Date())
      });
      setSuccess("Venta registrada");
      setShowSaleModal(false);
      setSaleProduct(null);
      setSaleUnits("");
    } catch (err) {
      setError("Error al registrar la venta");
    }
    setTimeout(() => { setError(""); setSuccess(""); }, 3000);
  };

  const handleRemoveQuantitySubmit = async (e) => {
    e.preventDefault();
    if (!removeProduct) return;
    const unitsToRemove = Number(removeUnits);
    if (unitsToRemove <= 0) {
      setError("La cantidad a eliminar debe ser mayor a 0");
      return;
    }
    if (unitsToRemove > removeProduct.cantidad) {
      setError("No puedes eliminar más unidades de las que hay en inventario");
      return;
    }
    try {
      const newCantidad = removeProduct.cantidad - unitsToRemove;
      await updateDoc(doc(db, 'stores', user.storeId, 'inventario', removeProduct.id), {
        cantidad: newCantidad,
        lastUpdated: Timestamp.fromDate(new Date())
      });
      setSuccess("Cantidad eliminada del inventario");
      setShowRemoveQuantityModal(false);
      setRemoveProduct(null);
      setRemoveUnits("");
    } catch (err) {
      setError("Error al eliminar la cantidad");
    }
    setTimeout(() => { setError(""); setSuccess(""); }, 3000);
  };

  const resetSalesCounter = async () => {
    if (!window.confirm('¿Estás seguro de resetear el contador de ventas?')) return;
    try {
      const storesToUpdate = isMaster ? STORES : [user.storeId];
      for (const store of storesToUpdate) {
        const snapshot = await getDocs(collection(db, 'stores', store, 'inventario'));
        snapshot.docs.forEach(async (docItem) => {
          await updateDoc(docItem.ref, {
            ventas: 0,
            lastUpdated: Timestamp.fromDate(new Date())
          });
        });
      }
      setSuccess("Contador de ventas reseteado");
    } catch (err) {
      setError("Error al resetear el contador de ventas");
    }
    setTimeout(() => { setError(''); setSuccess(''); }, 3000);
  };

  const filteredProductCatalog = productCatalog.filter((product) =>
    product.nombre.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <Container className="my-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Gestión de Inventario - {user.storeId}</h2>
        <Button variant="danger" onClick={handleLogout}>Cerrar Sesión</Button>
      </div>
      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">{success}</Alert>}
      {isMaster && (
        <div className="mb-4">
          <Button variant="outline-dark" onClick={resetSalesCounter}>Resetear Ventas Global</Button>
        </div>
      )}
<Row className="mb-4">
  <Col>
    <Button variant="primary" onClick={() => setShowCreateProductModal(true)}>
      Crear Producto (Catálogo Inventario)
    </Button>
  </Col>
  <Col>
    <Button
      variant="warning"
      onClick={() => {
        setSelectedEditProductId('');
        setEditProductData({});
        setShowEditProductModal(true);
      }}
    >
      Editar Producto
    </Button>
  </Col>
  <Col>
    <Button variant="success" onClick={() => setShowAddInventoryModal(true)}>
      Añadir al Inventario
    </Button>
  </Col>
</Row>

<Form className="d-flex mb-3">
  <Form.Control
    type="text"
    placeholder="🔍 Buscar producto..."
    value={searchText}
    onChange={e => setSearchText(e.target.value)}
    style={{ maxWidth: '300px' }}
  />
  <Form.Select
    className="ms-2"
    value={filterCategory}
    onChange={e => setFilterCategory(e.target.value)}
    style={{ maxWidth: '200px' }}
  >
    <option value="">Todos los juegos</option>
    {categorias.map(cat => (
      <option key={cat} value={cat}>{cat}</option>
    ))}
  </Form.Select>
</Form>

      <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-4">
        <Tab eventKey="total" title="Total General">
        <Table striped bordered hover className="mt-3 text-center">
            <thead>
              <tr>
                <th>Producto</th>
                {STORES.map((store) => (<th key={store}>{store}</th>))}
                <th>Total Unidades</th>
                <th>Valor Total (₡)</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(calculateTotalInventory()).map(([nombre, data]) => (
                <tr key={nombre}>
                  <td>{nombre}</td>
                  {STORES.map((store) => (<td key={store}>{data.tiendas[store] || 0}</td>))}
                  <td><strong>{data.total}</strong></td>
                  <td><strong>₡{data.valor.toLocaleString()}</strong></td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Tab>
        {STORES.map((storeId) => (
          <Tab key={storeId} eventKey={storeId} title={storeId}>
            <Table striped bordered hover className="mt-3">
              <thead>
                <tr>
                  <th>Imagen</th>
                  <th>Producto</th>
                  <th>Juegos</th>
                  <th>Categoría</th>
                  <th>Precio Público</th>
                  <th>Stock</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
              {(
  allInventory[storeId] || []
)
  .filter(item =>
    item.nombre.toLowerCase().includes(searchText.toLowerCase()) &&
    (filterCategory === '' || item.categoria === filterCategory)
  )
  .map(item => (
    <tr key={item.id}>
      <td>{item.imageURL && <img src={item.imageURL} width="50" />}</td>
      <td>{item.nombre}</td>
      <td>{item.categoria}</td>
      <td>{item.tipo}</td>
      <td>₡{item.precioPublico?.toLocaleString()}</td>
      <td>{item.cantidad}</td>
      <td>
        <Button size="sm" onClick={() => { setSaleProduct(item); setShowSaleModal(true); }}>
          Vender
        </Button>
        {isMaster && (
          <Button size="sm" variant="danger" className="ms-2"
            onClick={() => handleDeleteProduct(item.id, storeId)}
          >
            Eliminar
          </Button>
        )}
        <Button size="sm" variant="warning" className="ms-2"
          onClick={() => { setRemoveProduct(item); setShowRemoveQuantityModal(true); }}
        >
          Eliminar 
        </Button>
      </td>
    </tr>
  ))
}

              </tbody>
            </Table>
          </Tab>
        ))}
      </Tabs>
      <Modal show={showCreateProductModal} onHide={() => {
  setShowCreateProductModal(false);
  setCreateProductData({});
}}>
  <Modal.Header closeButton>
    <Modal.Title>Crear Producto (Catálogo Inventario)</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form onSubmit={handleCreateProductSubmit}>
      {/* Nombre, Imagen y Descripción */}
      <Form.Group className="mb-3">
        <Form.Label>Nombre del Producto *</Form.Label>
        <Form.Control
          name="nombre"
          value={createProductData.nombre || ""}
          onChange={e => setCreateProductData(p => ({ ...p, nombre: e.target.value }))}
          required
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Imagen por URL *</Form.Label>
        <Form.Control
          name="imageURL"
          value={createProductData.imageURL || ""}
          onChange={e => setCreateProductData(p => ({ ...p, imageURL: e.target.value }))}
          required
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Descripción</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          name="descripcion"
          value={createProductData.descripcion || ""}
          onChange={e => setCreateProductData(p => ({ ...p, descripcion: e.target.value }))}
          placeholder="(opcional)"
        />
      </Form.Group>

      <Row>
        {/* Ahora este select es “Juego” */}
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Juego</Form.Label>
            <Form.Select
              value={createProductData.categoria || ""}
              onChange={e => {
                const v = e.target.value;
                if (v === "_newCategory") {
                  const nueva = prompt("Nombre de la nueva categoría:");
                  if (!nueva) return;
                  setCategorias(prev => [...prev, nueva]);
                  setGameCategoriesState(prev => ({ ...prev, [nueva]: [] }));
                  setCreateProductData(p => ({ ...p, categoria: nueva, tipo: "" }));
                } else {
                  setCreateProductData(p => ({ ...p, categoria: v, tipo: "" }));
                }
              }}
              required
            >
              <option value="">Seleccionar juego...</option>
              {categorias.map(cat => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
              <option value="_newCategory">+ Crear nuevo juego</option>
            </Form.Select>
          </Form.Group>
        </Col>

        {/* Y este select es “Categoría” */}
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Categoría</Form.Label>
            <Form.Select
              value={createProductData.tipo || ""}
              onChange={e => {
                const v = e.target.value;
                if (v === "_newGame") {
                  if (!createProductData.categoria) {
                    alert("Primero selecciona un juego");
                    return;
                  }
                  const nuevo = prompt(`Nueva categoría para "${createProductData.categoria}":`);
                  if (!nuevo) return;
                  setGameCategoriesState(prev => ({
                    ...prev,
                    [createProductData.categoria]: [
                      ...prev[createProductData.categoria],
                      nuevo
                    ]
                  }));
                  setCreateProductData(p => ({ ...p, tipo: nuevo }));
                } else {
                  setCreateProductData(p => ({ ...p, tipo: v }));
                }
              }}
              required
            >
              <option value="">Seleccionar categoría...</option>
              {(gameCategoriesState[createProductData.categoria] || []).map((opt,i) => (
                <option key={i} value={opt}>{opt}</option>
              ))}
              <option value="_newGame">+ Crear nueva categoría</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      {/* Precio y botones */}
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Precio Distribuidor (CRC) *</Form.Label>
            <Form.Control
              type="number"
              value={createProductData.precioDistribuidor || ""}
              onChange={e => setCreateProductData(p => ({ ...p, precioDistribuidor: e.target.value }))}
              min="0"
              step="100"
              required
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Precio Público (CRC) *</Form.Label>
            <Form.Control
              type="number"
              value={createProductData.precioPublico || ""}
              onChange={e => setCreateProductData(p => ({ ...p, precioPublico: e.target.value }))}
              min="0"
              step="100"
              required
            />
          </Form.Group>
        </Col>
      </Row>
      <div className="d-flex justify-content-end gap-2">
        <Button variant="secondary" onClick={() => setShowCreateProductModal(false)}>Cancelar</Button>
        <Button variant="primary" type="submit">Guardar Producto</Button>
      </div>
    </Form>
  </Modal.Body>
</Modal>

      <Modal
  show={showEditProductModal}
  onHide={() => {
    setShowEditProductModal(false);
    setEditProductData({});
  }}
>
  <Modal.Header closeButton>
    <Modal.Title>Editar Producto (Catálogo Inventario)</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form onSubmit={handleEditProductSubmit}>
      {/* Selector de producto */}
      <Form.Group className="mb-3">
        <Form.Label>Producto *</Form.Label>
        <Form.Select
          value={selectedEditProductId}
          onChange={e => {
            const id = e.target.value;
            setSelectedEditProductId(id);
            const prod = productCatalog.find(p => p.id === id);
            setEditProductData(prod || {});
          }}
          required
        >
          <option value="">Seleccionar producto...</option>
          {productCatalog.map(p => (
            <option key={p.id} value={p.id}>
              {p.nombre} (₡{p.precioPublico?.toLocaleString()})
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      {/* Campos (idénticos al crear) */}
      <Form.Group className="mb-3">
        <Form.Label>Nombre *</Form.Label>
        <Form.Control
          value={editProductData.nombre || ''}
          onChange={e => setEditProductData(prev => ({ ...prev, nombre: e.target.value }))}
          required
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Imagen URL *</Form.Label>
        <Form.Control
          value={editProductData.imageURL || ''}
          onChange={e => setEditProductData(prev => ({ ...prev, imageURL: e.target.value }))}
          required
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Descripción</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          value={editProductData.descripcion || ''}
          onChange={e => setEditProductData(prev => ({ ...prev, descripcion: e.target.value }))}
        />
      </Form.Group>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Juegos *</Form.Label>
            <Form.Select
              value={editProductData.categoria || ''}
              onChange={e => setEditProductData(prev => ({ ...prev, categoria: e.target.value, tipo: '' }))}
              required
            >
              <option value="">Seleccionar...</option>
              {categorias.map(c => <option key={c} value={c}>{c}</option>)}

            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Categoría *</Form.Label>
            <Form.Select
              value={editProductData.tipo || ''}
              onChange={e => setEditProductData(prev => ({ ...prev, tipo: e.target.value }))}
              required
            >
              <option value="">Seleccionar...</option>
              {gameCategoriesState[editProductData.categoria]?.map((opt,i) => (
                <option key={i} value={opt}>{opt}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Precio Distribuidor *</Form.Label>
            <Form.Control
              type="number"
              value={editProductData.precioDistribuidor || ''}
              onChange={e => setEditProductData(prev => ({ ...prev, precioDistribuidor: e.target.value }))}
              required
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Precio Público *</Form.Label>
            <Form.Control
              type="number"
              value={editProductData.precioPublico || ''}
              onChange={e => setEditProductData(prev => ({ ...prev, precioPublico: e.target.value }))}
              required
            />
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex justify-content-end gap-2">
        <Button variant="secondary" onClick={() => setShowEditProductModal(false)}>
          Cancelar
        </Button>
        <Button variant="warning" type="submit">
          Guardar Cambios
        </Button>
      </div>
    </Form>
  </Modal.Body>
</Modal>

      <Modal show={showAddInventoryModal} onHide={() => { setShowAddInventoryModal(false); setAddInventoryData({ productId: "", cantidad: "", catalog: true }); setSearchText(""); }}>
        <Modal.Header closeButton>
          <Modal.Title>Añadir Producto al Inventario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Control type="text" placeholder="Buscar producto..." value={searchText} onChange={(e) => setSearchText(e.target.value)} />
          </Form.Group>
          <Form onSubmit={handleAddInventorySubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Producto *</Form.Label>
              <Form.Select value={addInventoryData.productId || ""} onChange={(e) => setAddInventoryData(prev => ({ ...prev, productId: e.target.value }))} required>
                <option value="">Seleccionar producto...</option>
                {filteredProductCatalog.map(product => (<option key={product.id} value={product.id}>{product.nombre} (₡{product.precioPublico?.toLocaleString()})</option>))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Cantidad *</Form.Label>
              <Form.Control type="number" min="1" value={addInventoryData.cantidad || ""} onChange={(e) => setAddInventoryData(prev => ({ ...prev, cantidad: e.target.value }))} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check type="switch" label="Mostrar en catálogo" checked={addInventoryData.catalog ?? true} onChange={(e) => setAddInventoryData(prev => ({ ...prev, catalog: e.target.checked }))} />
            </Form.Group>
            <div className="d-flex justify-content-end gap-2">
              <Button variant="secondary" onClick={() => setShowAddInventoryModal(false)}>Cancelar</Button>
              <Button variant="primary" type="submit">Añadir</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal show={showSaleModal} onHide={() => { setShowSaleModal(false); setSaleProduct(null); setSaleUnits(""); }}>
        <Modal.Header closeButton>
          <Modal.Title>Vender Unidad - {saleProduct?.nombre}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSaleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Unidades a vender (Stock disponible: {saleProduct?.cantidad || 0})</Form.Label>
              <Form.Control type="number" min="1" max={saleProduct?.cantidad} value={saleUnits || ""} onChange={(e) => setSaleUnits(e.target.value)} required />
            </Form.Group>
            <div className="d-flex justify-content-end gap-2">
              <Button variant="secondary" onClick={() => { setShowSaleModal(false); setSaleProduct(null); setSaleUnits(""); }}>Cancelar</Button>
              <Button variant="primary" type="submit">Confirmar Venta</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal show={showRemoveQuantityModal} onHide={() => { setShowRemoveQuantityModal(false); setRemoveProduct(null); setRemoveUnits(""); }}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar Cantidad - {removeProduct?.nombre}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleRemoveQuantitySubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Cantidad a eliminar (Stock disponible: {removeProduct?.cantidad || 0})</Form.Label>
              <Form.Control type="number" min="1" max={removeProduct?.cantidad} value={removeUnits || ""} onChange={(e) => setRemoveUnits(e.target.value)} required />
            </Form.Group>
            <div className="d-flex justify-content-end gap-2">
              <Button variant="secondary" onClick={() => { setShowRemoveQuantityModal(false); setRemoveProduct(null); setRemoveUnits(""); }}>Cancelar</Button>
              <Button variant="warning" type="submit">Confirmar Eliminación</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

const InventoryPage = () => {
  const [firebaseUser, setFirebaseUser] = useState(null);
  const [storeUser,    setStoreUser]    = useState(null);

  useEffect(() => {
    // 1. Persistencia en localStorage
    setPersistence(auth, browserLocalPersistence)
      .catch(console.error);

    // 2. Suscripción al estado de auth
    const unsub = onAuthStateChanged(auth, async user => {
      setFirebaseUser(user);
      if (user) {
        // Trae storeId de Firestore
        const udoc = await getDoc(doc(db, 'users', user.uid));
        if (udoc.exists()) {
          setStoreUser({ uid: user.uid, ...udoc.data() });
        } else {
          signOut(auth);
          setStoreUser(null);
        }
      } else {
        setStoreUser(null);
      }
    });

    return unsub;
  }, []);

  if (!storeUser) {
    // Mientras no haya sesión, muestra el login
    return <InventoryLogin />;
  }

  // Si hay sesión, renderiza el panel
  return (
    <InventoryPanel
      user={storeUser}
      handleLogout={() => signOut(auth)}
    />
  );
};

export default InventoryPage;
